export default __webpack_public_path__ + "static/media/ic_russia.1cabed04.svg";